// @ts-nocheck -- legacy receiving contracts are migrated incrementally below.
import React, { useEffect, useRef, useState } from "react";

import { Dialog } from "@headlessui/react";
import { MagnifyingGlassIcon, XMarkIcon } from "@heroicons/react/24/outline";

export default function AssemblyItemsTableComponent(props) {
  const { assemblyItemsList, setItemValues, setOpen } = props;

  const searchRef = useRef();

  const [assemblyItems, setAssemblyItems] = useState([]);

  useEffect(() => {
    setAssemblyItems(assemblyItemsList);
  }, [assemblyItemsList]);

  const handleSearch = () => {
    const newAssemblyItems = assemblyItemsList.filter((item) =>
      item.product_name
        .toLowerCase()
        .includes(searchRef.current.value.toLowerCase()),
    );

    setAssemblyItems(newAssemblyItems);
  };

  return (
    <div className="flex h-full flex-col divide-y divide-[#E2E8F0] bg-white">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
        <div className="px-4 sm:px-6">
          <div className="flex items-start justify-between">
            <Dialog.Title className="text-base font-semibold leading-6 text-[#0F172A]">
              Choose a supplier item
            </Dialog.Title>
            <div className="ml-3 flex h-7 items-center">
              <button
                type="button"
                className="rounded-md bg-white text-[#64748B]/70 hover:text-[#64748B] focus:outline-none focus:ring-2 focus:ring-[#2563EB]"
                onClick={() => setOpen({ childComponent: null, open: false })}
              >
                <span className="sr-only">Close panel</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
          </div>
          <div className="mt-2 flex rounded-md">
            <div className="relative flex items-stretch flex-grow focus-within:z-10">
              <input
                type="search"
                name="searchInput"
                id="searchInput"
                className="block w-full rounded-l-xl border border-[#E2E8F0] px-3 py-2 text-sm text-[#0F172A] placeholder:text-[#64748B]/70 focus:border-[#2563EB] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/10"
                placeholder="Search by name"
                ref={searchRef}
                onKeyDown={(e) => (e.key === "Enter" ? handleSearch() : null)}
              />
            </div>
            <button
              type="button"
              className="-ml-px relative inline-flex items-center space-x-2 rounded-r-xl border border-[#E2E8F0] bg-white px-4 py-2 text-sm font-medium text-[#0F172A] hover:bg-[#EFF6FF] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/10"
              onClick={() => handleSearch()}
            >
              <MagnifyingGlassIcon
                className="h-5 w-5 text-[#64748B]/70"
                aria-hidden="true"
              />
            </button>
          </div>
        </div>
        <div className="relative mt-6 flex-1 px-4 sm:px-6">
          <div
            id="product-table"
            className="overflow-hidden rounded-[18px] border border-[#E2E8F0] bg-white shadow-[0_1px_2px_rgba(15,23,42,0.04)]"
          >
            <table className="min-w-full border-separate border-spacing-0">
              <thead className="bg-[#EFF6FF]">
                <tr>
                  <th
                    scope="col"
                    className="border-b border-[#E2E8F0] px-4 py-3 text-left text-[11px] font-semibold uppercase tracking-[0.08em] text-[#64748B] sm:pl-5"
                  >
                    Name / Product code
                  </th>
                  <th
                    scope="col"
                    className="border-b border-[#E2E8F0] px-4 py-3 text-left text-[11px] font-semibold uppercase tracking-[0.08em] text-[#64748B]"
                  >
                    Manufacturer
                  </th>
                  <th
                    scope="col"
                    className="border-b border-[#E2E8F0] px-4 py-3 text-left text-[11px] font-semibold uppercase tracking-[0.08em] text-[#64748B]"
                  >
                    Manufacturer Plu
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-[#E2E8F0] bg-white">
                {assemblyItems.map((assemblyItem) => (
                  <tr
                    key={assemblyItem.id}
                    className="cursor-pointer transition hover:bg-[#F6F8FB]"
                    onClick={() => {
                      setItemValues(assemblyItem);
                      setOpen({ childComponent: null, open: false });
                    }}
                  >
                    <td className="border-b border-[#E2E8F0]/70 px-4 py-3.5 text-sm font-semibold text-[#0F172A] sm:pl-5">
                      {assemblyItem.product_name} <br />
                      {assemblyItem.plu}
                    </td>
                    <td className="border-b border-[#E2E8F0]/70 px-4 py-3.5 text-sm text-[#64748B]">
                      {assemblyItem.manufacturer_name}
                    </td>
                    <td className="border-b border-[#E2E8F0]/70 px-4 py-3.5 text-sm text-[#64748B]">
                      {assemblyItem.manufacturer_plu}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
